import { isVac } from 'utilities/is-vac';
import { httpClient } from '..';

import {
  QuiltsResponseMega,
  TQuiltCreateUpdate,
  TQuiltSearchRequest,
  TQuiltType,
  TSearchQuiltResponse,
} from '../types';

export const fetchPublicQuiltWithMemorial = async (id: string | number) => {
  const data = await httpClient.get(`quilts/${id}/shared/public`);
  return data;
};

export const editUnpublishedQuilt = async (id: string): Promise<any> => {
  const { data } = await httpClient.get(`/quilts/${id}`);
  
  if (!data?.returned?.id) return;

  const quiltForEditing = {
    ...data.returned,
    access: data?.returned?.access || '',
    isInvitedUser: data.returned?.isInvitedUser || false,
  };

  return quiltForEditing;
};

export const getMemorial = async (id: string): Promise<any> => {
  const { data } = await httpClient.get(`/quilts/${id}`);

  return data.returned.memorial || '';
};

export const getImagesOfQuilt = async (id: string): Promise<Pick<TQuiltCreateUpdate, 'album' | 'finalImage'> | null> => {
  const { data } = await httpClient.get(`/quilts/${id}`);
  const { finalImage, album } = data.returned;

  if (data) {
    return { finalImage, album };
  }

  return null;
};

export const searchQuilts = async (
  search: TQuiltSearchRequest
): Promise<TSearchQuiltResponse[]> => {
  const { data } = await httpClient.post('/quilts/search', {
    data: search,
  });
  return data.returned;
};

export const getSimpleQuilt = async (id: string) => {
  const { data } = await httpClient.get(`/quilts/${id}/simple`);
  return data.returned as TQuiltType;
};

export const getQuiltsMega = async (limit: number) => {
  const { data } = await httpClient.get(`/quilts/mega`, {
    params: {
      limit,
    },
  });

  return data.returned as QuiltsResponseMega[];
};
